import type { ScrollableRef } from '@shopify/polaris';

import { PICK_RESOURCE_SCROLL_VARIANT } from './constants';
import { Scrollable } from '@shopify/polaris';
import { forwardRef } from 'react';
import clsx from 'clsx';

interface IProps {
  children: React.ReactNode;
  variant?: keyof typeof PICK_RESOURCE_SCROLL_VARIANT;
  horizontal?: boolean;
  className?: string;
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
  onScrolledToBottom?: () => void;
}

// Shared scrollable body for pick-resource modals: a height-bounded Scrollable wrapping a
// min-height inner box so the empty state fills the viewport instead of collapsing.
export const GPickResourceScrollable = forwardRef<ScrollableRef, IProps>(
  function GPickResourceScrollable(
    { children, variant = 'default', horizontal = false, className, onScroll, onScrolledToBottom },
    ref,
  ) {
    const { scrollable, content } = PICK_RESOURCE_SCROLL_VARIANT[variant];
    const scrollableClassName = clsx(scrollable, className);

    return (
      <Scrollable
        ref={ref}
        scrollbarWidth="thin"
        vertical
        horizontal={horizontal}
        onScroll={onScroll}
        onScrolledToBottom={onScrolledToBottom}
        className={scrollableClassName}
      >
        <div className={content}>{children}</div>
      </Scrollable>
    );
  },
);
